module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "organization-home pt-0"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-div"
  }, [_c('v-progress-circular', {
    staticClass: "loading-icon",
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('Dialog', {
    attrs: {
      "dialog": _vm.deleteFieldDialog.show,
      "cardText": _vm.deleteFieldDialog.cardText,
      "mainBtnText": _vm.deleteFieldDialog.mainBtnText,
      "secondaryBtnText": _vm.deleteFieldDialog.secondaryBtnText,
      "alertColor": true
    },
    on: {
      "update:dialog": function($event) {
        return _vm.$set(_vm.deleteFieldDialog, "show", $event)
      },
      "mainBtnCallback": _vm.deleteField
    }
  }), _vm._v(" "), (_vm.deviceDetailDialog) ? _c('v-dialog', {
    attrs: {
      "width": "500",
      "content-class": "device-detail-dialog"
    },
    model: {
      value: (_vm.deviceDetailDialog),
      callback: function($$v) {
        _vm.deviceDetailDialog = $$v
      },
      expression: "deviceDetailDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5 lighten-2 text-break"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('OrganizationData.deviceDetail', {
    name: _vm.deviceDetailSelected.campaign.entityName
  })) + "\n      ")]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "pt-0 pl-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('p', {
    staticClass: "section-title mb-2",
    staticStyle: {
      "color": "#000000DE"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.users')))]), _vm._v(" "), (_vm.deviceDetailSelected.users.length) ? _vm._l((_vm.deviceDetailSelected.users), function(user) {
    return _c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "color": "#000000DE"
      }
    }, [_vm._v(_vm._s(_vm.getUserFullName(user.id)))])
  }) : _c('p', [_vm._v(_vm._s(_vm.$t('OrganizationData.noAssignedUsers')))])], 2), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0 pl-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('p', {
    staticClass: "section-title mb-2",
    staticStyle: {
      "color": "#000000DE"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.crops')))]), _vm._v(" "), (_vm.deviceDetailSelected.campaign.crops.length) ? _vm._l((_vm.deviceDetailSelected.campaign.crops), function(crop) {
    return _c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "color": "#000000DE"
      }
    }, [_vm._v(_vm._s(crop.name) + " (" + _vm._s(_vm.getFieldName(crop.field)) + ")")])
  }) : _c('p', [_vm._v(_vm._s(_vm.$t('OrganizationData.noAssignedCrops')))])], 2)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pendingCampaignOnboardingDialog) ? _c('v-dialog', {
    attrs: {
      "width": "auto",
      "persistent": ""
    },
    model: {
      value: (_vm.pendingCampaignOnboardingDialog),
      callback: function($$v) {
        _vm.pendingCampaignOnboardingDialog = $$v
      },
      expression: "pendingCampaignOnboardingDialog"
    }
  }, [_c('div', {
    staticClass: "pending-campaign-onboarding-dialog"
  }, [_c('v-card', {
    staticClass: "py-4 px-4",
    attrs: {
      "color": "#EEF2F5",
      "rounded": "lg"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pt-4"
  }, [_c('v-img', {
    attrs: {
      "src": require('@/assets/icons/alert.png'),
      "max-width": "1.5rem",
      "max-height": "1.5rem"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-text ml-2 mb-0"
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.pendingCampaignOnboardingDialogTitle')))])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-text text-center px-6 mt-4"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('OrganizationData.pendingCampaignOnboardingDialogText')) + "\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-row', [_c('v-col', {
    attrs: {
      "align": "end"
    }
  }, [_c('v-btn', {
    staticClass: "secondary-button",
    attrs: {
      "color": "#FFFFFF"
    },
    on: {
      "click": _vm.pendingCampaignOnboardingRemindMeLater
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('OrganizationData.pendingCampaignOnboardingDialogRemindMeLater')) + "\n              ")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "align": "start"
    }
  }, [_c('v-btn', {
    staticClass: "confirm-button",
    attrs: {
      "color": "#0098E1",
      "medium": ""
    },
    on: {
      "click": _vm.pendingCampaignOnboardingConfirm
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('OrganizationData.pendingCampaignOnboardingDialogConfirm')) + "\n              ")])], 1)], 1)], 1)], 1)], 1)]) : (_vm.devicesWithPendingPostponementRequests.length) ? _c('PostponementRequestDialog', {
    attrs: {
      "devices": _vm.devicesWithPendingPostponementRequests
    },
    on: {
      "update:devices": function($event) {
        _vm.devicesWithPendingPostponementRequests = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.addUserDialog) ? _c('AddUserDialog', {
    attrs: {
      "dialog": _vm.addUserDialog,
      "fromNewCampaign": false,
      "campaignId": _vm.currentCampaignId
    },
    on: {
      "update:dialog": function($event) {
        _vm.addUserDialog = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.serviceExtensionDialog.show) ? _c('ServiceExtensionDialog', {
    attrs: {
      "dialog": _vm.serviceExtensionDialog.show,
      "device": _vm.serviceExtensionDialog.device
    },
    on: {
      "update:dialog": function($event) {
        return _vm.$set(_vm.serviceExtensionDialog, "show", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-div",
    attrs: {
      "id": "header-div"
    }
  }, [_c('v-row', {
    staticClass: "py-2"
  }, [_c('v-col', {
    staticClass: "py-0 px-0",
    class: _vm.display === 'xs' || _vm.display === 'sm' ? 'text-center place-items-center' : '',
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "campaign-header-container"
  }, [_c('h3', {
    staticClass: "header-main",
    class: _vm.display === 'xs' || _vm.display === 'sm' ? 'py-1' : 'py-3'
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('OrganizationData.dashboard')))]), _vm._v(" " + _vm._s(_vm.organization))]), _vm._v(" "), _c('div', {
    class: _vm.$store.getters.availableCampaigns.length ? 'campaign-selector-container' : 'campaign-selector-container-empty'
  }, [(_vm.$store.getters.availableCampaigns.length) ? _c('p', {
    staticClass: "body-text",
    on: {
      "click": _vm.toggleCampaignMenu
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('EditCampaign.service')))]), _vm._v("\n              " + _vm._s(_vm.selectedCampaign ? _vm.selectedCampaign.name : '') + "\n            ")]) : _c('p', {
    staticClass: "body-text"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('EditCampaign.emptyCampaigns')))])]), _vm._v(" "), (_vm.$store.getters.availableCampaigns.length) ? [(_vm.selectedCampaign) ? _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "text": "",
      "fab": "",
      "x-small": ""
    },
    on: {
      "click": _vm.editCampaign
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#00202F",
      "size": "16"
    }
  }, [_vm._v("mdi-pencil")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "text": "",
      "fab": "",
      "x-small": ""
    },
    on: {
      "click": _vm.toggleCampaignMenu
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#00202F",
      "size": "18"
    }
  }, [_vm._v(_vm._s(_vm.campaignMenuExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.campaignMenuExpanded),
      expression: "campaignMenuExpanded"
    }],
    staticClass: "campaign-menu"
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.availableCampaigns), function(campaign) {
    return _c('v-list-item', {
      key: campaign.id,
      class: {
        'selected-campaign': _vm.selectedCampaign && _vm.selectedCampaign.id === campaign.id
      },
      on: {
        "click": function($event) {
          return _vm.selectCampaign(campaign)
        }
      }
    }, [_c('v-list-item-title', [_c('b', [_vm._v(_vm._s(campaign.name))]), _vm._v(" "), (campaign.fromDate) ? _c('span', {
      staticClass: "campaign-date"
    }, [_vm._v("\n                    (" + _vm._s(_vm.formatCampaignDate(campaign.fromDate, campaign.toDate)) + ")\n                  ")]) : _vm._e()])], 1)
  }), 1)], 1)])]), _vm._v(" "), _c('v-col', {
    staticClass: "py-0 px-0",
    staticStyle: {
      "align-self": "center"
    },
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-row', {
    staticClass: "section-menu-text",
    class: _vm.display === 'xs' || _vm.display === 'sm' ? 'justify-content-center' : 'justify-content-right'
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('a', {
    staticClass: "section-menu-text",
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "devices-section-menu"
    },
    on: {
      "click": function($event) {
        return _vm.goToSection('devices')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.devices')))]), _vm._v(" | "), _c('a', {
    staticClass: "section-menu-text",
    attrs: {
      "id": "fields-section-menu"
    },
    on: {
      "click": function($event) {
        return _vm.goToSection('fields')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.fields')))]), _vm._v(" | "), _c('a', {
    staticClass: "section-menu-text",
    attrs: {
      "id": "users-section-menu"
    },
    on: {
      "click": function($event) {
        return _vm.goToSection('users')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.users')))])])])], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-container', {
    staticClass: "organization-data px-0",
    attrs: {
      "id": "organization-data"
    }
  }, [(_vm.showFinishCampaignOnboardingCard()) ? _c('div', {
    attrs: {
      "id": "finish-campaign-onboarding-section"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "finish-campaign-onboarding-card px-2"
  }, [_c('v-card-title', [_c('p', {
    staticClass: "title-text mb-0"
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.finishCampaignOnboarding.title')))])]), _vm._v(" "), _c('v-card-text', [_c('ol', [(_vm.devicesWithMissingData.length) ? _c('v-row', {
    staticClass: "mb-0 mt-1"
  }, [_c('li', {
    staticClass: "body-text my-1 mr-1"
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.finishCampaignOnboarding.requiredDevicesData')))]), _vm._v(" "), _c('v-row', [_vm._l((_vm.limitedDevicesWithMissingData), function(devWithMissingData) {
    return _c('div', {
      staticClass: "device-with-missing-data-card mx-1 my-1"
    }, [_c('p', {
      staticClass: "mb-0 mx-2"
    }, [_vm._v(_vm._s(devWithMissingData.campaign.entityName))])])
  }), _vm._v(" "), (_vm.devicesWithMissingData.length > _vm.DEVICES_WITH_MISSING_DATA_TO_SHOW) ? _c('p', {
    staticClass: "mb-0 ellipsis-text"
  }, [_vm._v("...")]) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.devicesWithoutAssignedCrops.length) ? _c('v-row', {
    staticClass: "mb-0 mt-1"
  }, [_c('li', {
    staticClass: "body-text my-1 mr-1"
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.finishCampaignOnboarding.addFieldsAndCrops')))]), _vm._v(" "), _c('v-row', [_vm._l((_vm.limitedDevicesWithoutCrops), function(devWithoutCrops) {
    return _c('div', {
      staticClass: "device-with-missing-data-card mx-1 my-1"
    }, [_c('p', {
      staticClass: "mb-0 mx-2"
    }, [_vm._v(_vm._s(devWithoutCrops.campaign.entityName))])])
  }), _vm._v(" "), (_vm.devicesWithoutAssignedCrops.length > _vm.DEVICES_WITHOUT_CROPS_TO_SHOW) ? _c('p', {
    staticClass: "mb-0 ellipsis-text"
  }, [_vm._v("...")]) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.devicesWithoutAssignedUsers.length) ? _c('v-row', {
    staticClass: "mb-0 mt-1"
  }, [_c('li', {
    staticClass: "body-text my-1 mr-1"
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.finishCampaignOnboarding.addUsers')))]), _vm._v(" "), _c('v-row', [_vm._l((_vm.limitedDevicesWithoutUsers), function(devWithoutUsers) {
    return _c('div', {
      staticClass: "device-with-missing-data-card mx-1 my-1"
    }, [_c('p', {
      staticClass: "mb-0 mx-2"
    }, [_vm._v(_vm._s(devWithoutUsers.campaign.entityName))])])
  }), _vm._v(" "), (_vm.devicesWithoutAssignedUsers.length > _vm.DEVICES_WITHOUT_USERS_TO_SHOW) ? _c('p', {
    staticClass: "mb-0 ellipsis-text"
  }, [_vm._v("...")]) : _vm._e()], 2)], 1) : _vm._e()], 1)])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.devicesNearEndOfService.length) ? _c('div', {
    attrs: {
      "id": "services-soon-to-end-section"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "finish-campaign-onboarding-card px-2"
  }, [_c('v-card-title', [_c('p', {
    staticClass: "title-text mb-0"
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.servicesSoonToEnd.title')))])]), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "d-flex align-center flex-wrap mb-3"
  }, [_c('p', {
    staticClass: "body-text mb-0 mr-3"
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.servicesSoonToEnd.mainDescription')))]), _vm._v(" "), _vm._l((_vm.limitedDevicesNearEndOfService), function(device) {
    return _c('div', {
      key: device.id,
      staticClass: "device-with-missing-data-card mx-1 my-1"
    }, [_c('p', {
      staticClass: "mb-0 mx-2"
    }, [_vm._v(_vm._s(device.campaign.entityName))])])
  }), _vm._v(" "), (_vm.devicesNearEndOfService.length > _vm.DEVICES_NEAR_END_OF_SERVICE_TO_SHOW) ? _c('p', {
    staticClass: "mb-0 ellipsis-text"
  }, [_vm._v("...")]) : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "body-text mb-0"
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.servicesSoonToEnd.extensionInfo')))])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "devices-section"
    }
  }, [_c('v-row', {
    staticClass: "section-header pt-5 px-3"
  }, [_c('p', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.devices')))])]), _vm._v(" "), _c('v-layout', {
    staticClass: "devices-list",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.devices.length) ? _vm._l((_vm.devices), function(dev) {
    return _c('v-flex', {
      key: dev.id,
      staticClass: "px-3 py-3",
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('div', {
      class: ['device-container', {
        'with-banner': _vm.isNearEndOfService(dev)
      }]
    }, [(_vm.isNearEndOfService(dev)) ? _c('div', {
      staticClass: "monitoring-finalize-banner"
    }, [_c('p', {
      staticClass: "monitoring-finalize-text"
    }, [_vm._v(_vm._s(_vm.$t('OrganizationData.monitoringToFinalize')))])]) : _vm._e(), _vm._v(" "), _c('v-card', {
      staticClass: "device-card"
    }, [_c('v-card-title', [_c('v-layout', [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-img', {
      attrs: {
        "src": require('@/assets/min-irrigation.png')
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "px-1",
      attrs: {
        "xs8": ""
      }
    }, [_c('p', {
      staticClass: "device-header-title ma-0"
    }, [_vm._v(_vm._s(dev.campaign.entityName))]), _vm._v(" "), _c('p', {
      staticClass: "device-header-subtitle ma-0"
    }, [_vm._v(_vm._s(_vm.getDeviceFieldName(dev)))]), _vm._v(" "), _c('p', {
      staticClass: "device-header-subtitle ma-0",
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(_vm.getEquipmentType(dev.equipment.type))), (_vm.isUserAdmin) ? _c('span', [_vm._v(" - ID: " + _vm._s(dev.id))]) : _vm._e()]), _vm._v(" "), (dev.equipment.type == _vm.EQUIPMENT_TYPE.AF) ? _c('p', {
      staticClass: "device-header-subtitle ma-0",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(_vm.getLinearEquipmentSubtype(dev.equipment.subtype)))]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            staticClass: "menu-btn",
            attrs: {
              "dark": "",
              "text": "",
              "icon": "",
              "color": "#00202F"
            },
            on: {
              "click": function($event) {
                return _vm.openDeviceMenu(dev)
              }
            }
          }, on), [_c('v-icon', [_vm._v("more_horiz")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', {
      staticClass: "pa-0"
    }, [(_vm.canEditDevice(dev)) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editDevice(dev)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('OrganizationData.edit')))])], 1) : _vm._e(), _vm._v(" "), (_vm.isNearEndOfService(dev)) ? [_c('v-divider', {
      staticClass: "mx-2"
    }), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.queryServiceExtension(dev)
        }
      }
    }, [_c('v-list-item-title', {
      staticClass: "device-header-extension-btn"
    }, [_vm._v(_vm._s(_vm.$t('OrganizationData.queryServiceExtension')))])], 1)] : _vm._e()], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [(!dev.hasCompleteData) ? _c('p', {
      staticClass: "mb-1",
      staticStyle: {
        "color": "#F93A2F"
      }
    }, [_c('v-icon', {
      staticClass: "mr-1",
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "size": "0.9rem",
        "color": "#F93A2F"
      }
    }, [_vm._v("mdi-alert-octagon-outline")]), _vm._v(_vm._s(_vm.$t('OrganizationData.requiredDeviceData')))], 1) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "mb-1",
      style: (("cursor: pointer; color: " + (dev.users.length === 0 ? '#F93A2F' : '#00202F'))),
      on: {
        "click": function($event) {
          return _vm.openDeviceDetailsDialog(dev)
        }
      }
    }, [_vm._v(_vm._s(dev.users.length == 1 ? _vm.$t('OrganizationData.assignedUserQty', {
      users: 1
    }) : _vm.$t('OrganizationData.assignedUsersQty', {
      users: dev.users.length
    })))]), _vm._v(" "), _c('p', {
      staticClass: "mb-1",
      style: (("cursor: pointer; color: " + (dev.campaign.crops.length === 0 ? '#F93A2F' : '#00202F'))),
      on: {
        "click": function($event) {
          return _vm.openDeviceDetailsDialog(dev)
        }
      }
    }, [_vm._v(_vm._s(dev.campaign.crops.length == 1 ? _vm.$t('OrganizationData.deviceCropQty', {
      crops: 1
    }) : _vm.$t('OrganizationData.deviceCropsQty', {
      crops: dev.campaign.crops.length
    })))]), _vm._v(" "), (_vm.deviceActivePluviometricChartFile(dev)) ? _c('a', {
      staticClass: "device-sheet-link",
      on: {
        "click": function($event) {
          _vm.downloadPluviometricChart(_vm.deviceActivePluviometricChartFile(dev), dev)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('OrganizationData.pluviometricChart')) + "\n                  ")]) : _c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "color": "#00202F"
      }
    }, [_vm._v(_vm._s(_vm.$t('OrganizationData.withoutPluviometricChart')))])])], 1)], 1)])
  }) : _c('div', {
    staticClass: "empty-div"
  }, [_c('p', {
    staticClass: "empty-list-text mt-1 mb-0"
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.emptyDevices')))])])], 2)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "fields-section"
    }
  }, [_c('v-row', {
    staticClass: "section-header pt-5 px-3"
  }, [_c('p', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.fields')))]), _vm._v(" "), (_vm.$store.getters.availableCampaigns.length) ? _c('a', {
    staticClass: "add-elem-btn px-5",
    on: {
      "click": _vm.addField
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('OrganizationData.addField')))]) : _vm._e()]), _vm._v(" "), _c('v-layout', {
    staticClass: "fields-list",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.fields.length) ? _vm._l((_vm.fields), function(field) {
    return _c('v-flex', {
      key: field.id,
      staticClass: "px-3 py-3",
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('v-card', {
      staticClass: "field-card",
      on: {
        "click": function($event) {
          return _vm.manageField(field)
        }
      }
    }, [_c('v-card-title', [_c('v-layout', [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-img', {
      attrs: {
        "src": require('@/assets/min-field.png')
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "px-1",
      attrs: {
        "xs8": ""
      }
    }, [_c('p', {
      staticClass: "field-header-title ma-0"
    }, [_vm._v(_vm._s(field.name))]), _vm._v(" "), _c('p', {
      staticClass: "field-header-subtitle ma-0"
    }, [_vm._v(_vm._s(_vm.getUserFullName(field.contact)))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            staticClass: "menu-btn",
            attrs: {
              "dark": "",
              "text": "",
              "icon": "",
              "color": "#00202F"
            },
            on: {
              "click": function($event) {
                return _vm.openFieldMenu(field)
              }
            }
          }, on), [_c('v-icon', [_vm._v("more_horiz")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', {
      staticClass: "pa-0"
    }, [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editField(field)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('OrganizationData.edit')))])], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "mx-2"
    }), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteFieldHandler(field)
        }
      }
    }, [_c('v-list-item-title', {
      staticStyle: {
        "color": "#F93A2F"
      }
    }, [_vm._v(_vm._s(_vm.$t('OrganizationData.delete')))])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v(_vm._s(field.crops && field.crops.length == 1 ? _vm.$t('OrganizationData.fieldCropQty', {
      crops: 1
    }) : _vm.$t('OrganizationData.fieldCropsQty', {
      crops: !field.crops ? 0 : field.crops.length
    })))])])], 1)], 1)
  }) : _c('div', {
    staticClass: "empty-div"
  }, [_c('p', {
    staticClass: "empty-list-text mt-1 mb-0"
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.emptyFields')))])])], 2)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "users-section"
    }
  }, [_c('v-row', {
    staticClass: "section-header pt-5 px-3"
  }, [_c('p', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.users')))]), _vm._v(" "), (_vm.$store.getters.availableCampaigns.length) ? _c('a', {
    staticClass: "add-elem-btn px-5",
    on: {
      "click": _vm.addUser
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('OrganizationData.addUser')))]) : _vm._e()]), _vm._v(" "), _c('v-layout', {
    staticClass: "users-list",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.users.length) ? _vm._l((_vm.users), function(user) {
    return _c('v-flex', {
      key: user.id,
      staticClass: "px-0 py-3",
      attrs: {
        "xs4": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('v-row', [_c('v-col', {
      staticClass: "text-center px-0"
    }, [_c('div', {
      staticClass: "user-img-div"
    }, [_c('div', {
      staticClass: "user-icon-div"
    }, [(user.photoUrl && !user.profilePic) ? _c('div', {
      staticClass: "loading-img-div"
    }, [_c('v-progress-circular', {
      staticClass: "v-progress-img",
      attrs: {
        "indeterminate": "",
        "color": "primary",
        "size": 50
      }
    })], 1) : _c('v-img', {
      staticClass: "user-img",
      attrs: {
        "height": "80",
        "max-width": "80",
        "src": _vm.getUserImg(user),
        "lazy-src": require('../../assets/blank.png')
      },
      on: {
        "click": function($event) {
          return _vm.editUser(user)
        }
      }
    }), _vm._v(" "), (user.email) ? _c('div', {
      staticClass: "user-icon-container"
    }, [_c('v-icon', {
      staticClass: "user-icon",
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("mdi-check-decagram")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('p', {
      staticClass: "user-name pt-3",
      on: {
        "click": function($event) {
          return _vm.editUser(user)
        }
      }
    }, [_vm._v(_vm._s(user.name) + " " + _vm._s(user.lastName))])])], 1)], 1)
  }) : _c('div', {
    staticClass: "empty-div"
  }, [_c('p', {
    staticClass: "empty-list-text mt-1 mb-0"
  }, [_vm._v(_vm._s(_vm.$t('OrganizationData.emptyUsers')))])])], 2)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b10bf44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrganizationHome/OrganizationHome.vue
// module id = 1694
// module chunks = 0